import Calendar from "react-calendar";

import { TranslatedText } from "@/components/common/text";

export const CalendarPanel = ({ value, onChange, selectRange = false, minDate, maxDate, onAny, onToday, onApply }) => (
    <div className="flex flex-col">
        <Calendar
            onChange={onChange}
            value={value}
            className="cm-calendar"
            locale="en-US"
            minDate={minDate}
            maxDate={maxDate}
            selectRange={selectRange}
            allowPartialRange={selectRange}
            formatShortWeekday={(locale, date) => date.toLocaleDateString(locale, { weekday: "short" }).slice(0, 2)}
        />
        <div className="flex w-full items-center gap-3 p-4 pt-3">
            {onAny ? (
                <button type="button" onClick={onAny} className="py-2 px-4 rounded-[58px] text-sm font-medium bg-cm-p-surface-container">
                    <TranslatedText text="Any" />
                </button>
            ) : null}
            <button type="button" onClick={onToday} className="py-2 px-4 rounded-[58px] text-sm font-medium bg-cm-p-surface-container">
                <TranslatedText text="Set today" />
            </button>
            <button
                type="button"
                onClick={onApply}
                className="py-2 px-4 rounded-lg text-sm font-medium bg-cm-p-accent-500 text-cm-p-neutral-dark-500 ml-auto min-w-[92px]"
            >
                <TranslatedText text="Apply" />
            </button>
        </div>
    </div>
);
